import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Popover,
} from "@mui/material";
import Register from "../../Page/User/Register";
import { useGlobal } from "../../Helper/Context/GlobalContext";
import Login from "../../Page/User/Login";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { Menu } from "@mui/icons-material";
function HeaderBtnLogout() {
  const sidebarContext = useGlobal();
  const { setToOpenMasuk } = sidebarContext;
  const history = useHistory();
  const [isAboutPage, setIsAboutPage] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;
  useEffect(() => {
    const aboutPage = currentPath.includes("tentang-kami");
    setIsAboutPage(aboutPage);
  }, [currentPath]);

  //==================================================Popover user
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClickView = (id) => {
    handleClose();
    const element = document.getElementById(`${id}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
      <Register />
      <Login />

      {isAboutPage ? (
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <List component="nav">
              <ListItem>
                <ListItemButton
                  onClick={() => {
                    handleClickView("cara-memesan");
                  }}
                >
                  <ListItemText primary="Cara Memesan" />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton
                  onClick={() => {
                    handleClickView("mengapa-inmemoriam");
                  }}
                >
                  <ListItemText primary="Mengapa InMemoriam" />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton
                  onClick={() => {
                    handleClickView("lokasi");
                  }}
                >
                  <ListItemText primary="Lokasi" />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton
                  onClick={() => {
                    handleClickView("template");
                  }}
                >
                  <ListItemText primary="Template" />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton
                  onClick={() => {
                    history.push("/gabung-mitra");
                  }}
                >
                  <ListItemText primary="Gabung Mitra" />
                </ListItemButton>
              </ListItem>
            </List>
          </Popover>
          <Box>
            <Button
              onClick={() => {
                handleClickView("cara-memesan");
              }}
              disableElevation
              variant="text"
              color="tertiary"
              size="small"
              sx={{
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: "400",
                marginRight: "5px",
              }}
            >
              Cara Memesan
            </Button>
            <Button
              onClick={() => {
                handleClickView("mengapa-inmemoriam");
              }}
              disableElevation
              variant="text"
              color="tertiary"
              size="small"
              sx={{
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: "400",
                marginRight: "5px",
              }}
            >
              Mengapa Inmemoriam
            </Button>
            <Button
              onClick={() => {
                handleClickView("lokasi");
              }}
              disableElevation
              variant="text"
              color="tertiary"
              size="small"
              sx={{
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: "400",
                marginRight: "5px",
              }}
            >
              Lokasi
            </Button>
            <Button
              onClick={() => {
                handleClickView("template");
              }}
              disableElevation
              variant="text"
              color="tertiary"
              size="small"
              sx={{
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: "400",
                marginRight: "5px",
              }}
            >
              Template
            </Button>

            <Button
              onClick={() => {
                history.push("/gabung-mitra");
              }}
              disableElevation
              variant="outlined"
              color="tertiary"
              size="small"
              sx={{
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: "400",
                marginRight: "5px",
              }}
            >
              Gabung Mitra
            </Button>
          </Box>
        </Box>
      ) : (
        <Button
          onClick={() => {
            history.push("/tentang-kami");
          }}
          disableElevation
          variant="text"
          color="tertiary"
          size="small"
          sx={{
            borderRadius: "999px",
            textTransform: "none",
            fontWeight: "400",
            marginRight: "5px",
            display: { xs: "none", sm: "block" },
          }}
        >
          Tentang Kami
        </Button>
      )}
      <Box>
        <Button
          onClick={() => {
            setToOpenMasuk();
          }}
          variant="contained"
          color="tertiary"
          size="small"
          sx={{
            borderRadius: "999px",
            textTransform: "none",
            fontWeight: "400",
          }}
        >
          Masuk
        </Button>
      </Box>
      {isAboutPage && (
        <Box
          sx={{
            display: { xs: "block", md: "none" },
          }}
        >
          <IconButton aria-label="menu" size="small" onClick={handleClick}>
            <Menu fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
}

export default HeaderBtnLogout;
